// components/bill-list/index
// список счетов

import template  from './template.jade'
import eventModal from 'lib/events/modal'

var name = 'bill-list'

export default {

  name: name,
  template: template(),
  mixins: [eventModal],

  data: () => ({
    name: name,
    modal: {show: false, components: []},
  }),
}



/** WEBPACK FOOTER **
 ** ./src/js/components/bill-list/index.js
 **/